import { Sprite } from 'pixi.js';
import { containerNames, frameNames } from '../../constants';
import { PixiBase } from '../../core/pixi/PixiBase';
import { Spine } from '../../services/elementTypeService/Spine';
import { applicationStore } from '../../store/applicationStore';
import { isMobile } from '../../helpers/isMobile';

export class SlotBoardDrawer {
  constructor() {
    this.animations = {};
    this.SlotBoardContainer = PixiBase.createContainer(containerNames.SlotBoardContainer);
  }

  createTournamentIcon() {
    this.tournamentIcon = Sprite.from(applicationStore.tournamentIconsInfo[0].imageUrl);
    this.tournamentIcon.scale.set(isMobile() ? 0.4 : 0.6);
    const { x, y, anchor } = this.config.TournamentIcon;
    PixiBase.setPosition(this.tournamentIcon, { x: x, y: y });
    this.tournamentIcon.anchor.set(anchor);
    this.tournamentIcon.visible = false;
    this.SlotBoardContainer.addChild(this.tournamentIcon);
  }

  setupSlotBoard() {
    this.slotBoard = new Spine({ key: 'slotBoard' });
    this.slotBoard.play('idle', true);
    const { x: slotBoardX, y: slotBoardY } = this.config.SlotBoardContainer.gameBoardConfig;
    PixiBase.setPosition(this.slotBoard, { x: slotBoardX, y: slotBoardY });
    const { x, y } = this.config.SlotBoardContainer;
    PixiBase.setPosition(this.SlotBoardContainer, { x: x, y: y });
    this.SlotBoardContainer.addChild(this.slotBoard);
  }

  setupGameLogo() {
    this.gameLogo = new Spine({ key: 'logo' });
    this.gameLogo.play('animation', true);
    const { x, y } = this.config.SlotBoardContainer.gameLogoConfig;
    PixiBase.setPosition(this.gameLogo, { x: x, y: y });
    this.SlotBoardContainer.addChild(this.gameLogo);
  }

  updateGameLogo() {
    PixiBase.changeFrame(this.gameLogo, frameNames.BigLogo);
    const { x, y } = this.config.SlotBoardContainer.bigMobileLogo;
    PixiBase.setPosition(this.gameLogo, { x: x, y: y });
  }

  execute(config, spriteSheet) {
    const [gameImageSpriteSheet] = spriteSheet;
    this.config = config;
    this.spriteSheet = gameImageSpriteSheet;
    this.setupSlotBoard();
    this.setupGameLogo();
    applicationStore.tournamentIconsInfo.length && this.createTournamentIcon();
  }
}
